import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { ConfirmOptionsModal } from 'stories/components'

const ConfirmOptionDialog = ({ show, proceed, promptation, options, selected, multi }: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <ConfirmOptionsModal
      isOpen={show}
      onOk={(result: any) => proceed(result as any)}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      title={promptation}
      options={options}
      selected={selected}
      multi={multi}
    />
  )
}

const confirmOptionDlg = confirmable(ConfirmOptionDialog)

const createConfirmOptions = createConfirmation(confirmOptionDlg)

export const confirmOptions = (
  content: string | JSX.Element,
  options: { name: string; value: any }[] = [],
  selected?: number,
  multi = false,
) => createConfirmOptions({ promptation: content, options, selected, multi })
